import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Unrealized Gain & Loss";
const description = `The Unrealized Gain & Loss Report tracks the potential profit or loss from foreign currency fluctuations on open (unsettled) transactions at a specific point in time, usually the end of an accounting period (like month-end or year-end). It is a "paper" gain or loss because no cash has exchanged hands to finalize the transaction. This report is generated to fulfill mandatory accounting requirements (such as GAAP or IFRS), which stipulate that monetary assets (like foreign-denominated Accounts Receivable/cash) and monetary liabilities (like foreign-denominated Accounts Payable/loans) must be revalued to the company's home currency using the prevailing closing exchange rate at the balance sheet date. The resulting unrealized gain or loss reflects the change in value of that open amount since it was first recorded or last revalued. This amount is typically recorded in a temporary account on the Income Statement or in the Equity section of the Balance Sheet, depending on the nature of the exposure.`;

const images = [
    '/images/reports/purchase-by-supplier/purchase-by-supplier.png', // 0
];


const UnrealizedGainLoss: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UnrealizedGainLoss;
